module.exports = __webpack_public_path__ + "img/icon-remove.c31508d7.svg";